import styled from '@emotion/styled';
import {Tooltip, tooltipClasses, TooltipProps} from '@mui/material';
import React, {ReactElement} from 'react';

type AppTooltipProps = {
  title: React.ReactNode | string;
  children: ReactElement;
  backgroundColor?: string;
} & Omit<TooltipProps, 'children' | 'title'>;

function AppTooltip({
  title,
  backgroundColor,
  children,
  ...rest
}: AppTooltipProps) {
  const HtmlTooltip = styled(({className, ...props}: TooltipProps) => (
    <Tooltip {...props} classes={{popper: className}} />
  ))(() => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: backgroundColor || '#ADE6F6',
      color: '#000',
      boxShadow: 'rgba(0, 0, 0, 0.1) 0px 4px 12px',
    },
  }));

  return (
    <HtmlTooltip title={title} placement="bottom-end" {...rest}>
      {children}
    </HtmlTooltip>
  );
}

export default AppTooltip;
